// extracted by mini-css-extract-plugin
export const stickyHeader = "propertyDetails-module--stickyHeader--3txcW";
export const logoWrap = "propertyDetails-module--logoWrap--1RQkH";
export const downloadBar = "propertyDetails-module--downloadBar--2HWjD";
export const dbFlex = "propertyDetails-module--dbFlex--XmcYm";
export const dbDesc = "propertyDetails-module--dbDesc--2nxLB";
export const descWrap = "propertyDetails-module--descWrap--14_JX";
export const mobileDesc = "propertyDetails-module--mobileDesc--3WfJe";
export const dbAction = "propertyDetails-module--dbAction--OaI3y";
export const ctaButton = "propertyDetails-module--ctaButton--EROQz";
export const sectionPropertyDetails = "propertyDetails-module--sectionPropertyDetails--2WfhF";
export const mobileStickFooter = "propertyDetails-module--mobileStickFooter--6BW22";
export const noMatch = "propertyDetails-module--noMatch--4IKss";
export const pdWrap = "propertyDetails-module--pdWrap--1QZtY";
export const blHtml = "propertyDetails-module--blHtml--3nkpQ";
export const blGallery = "propertyDetails-module--blGallery--3kw13";
export const galleryLabel = "propertyDetails-module--galleryLabel--1uP0Y";
export const mobileLabel = "propertyDetails-module--mobileLabel--38OSX";
export const galleryWrap = "propertyDetails-module--galleryWrap--3UQZE";
export const soloFeatured = "propertyDetails-module--soloFeatured--36dsn";
export const featuredCol = "propertyDetails-module--featuredCol--3_uy4";
export const moreCol = "propertyDetails-module--moreCol--3RzFb";
export const featuredImg = "propertyDetails-module--featuredImg--2H3aO";
export const moreImg = "propertyDetails-module--moreImg--3Uu2f";
export const imgBox = "propertyDetails-module--imgBox--tIK74";
export const lastImgBox = "propertyDetails-module--lastImgBox--3_cUL";
export const blDetails = "propertyDetails-module--blDetails--35Znd";
export const propDesc = "propertyDetails-module--propDesc--2yoF6";
export const readmore = "propertyDetails-module--readmore--WFzEY";
export const blIntroWrap = "propertyDetails-module--blIntroWrap--3qIge";
export const blIntro = "propertyDetails-module--blIntro--1pD4M";
export const adBanner = "propertyDetails-module--adBanner--3X8Zx";
export const stickyAdWrap = "propertyDetails-module--stickyAdWrap--3pJf8";
export const stickyMode = "propertyDetails-module--stickyMode--4CJf6";
export const iconsBar = "propertyDetails-module--iconsBar--3NJIk";
export const mlMapWrap = "propertyDetails-module--mlMapWrap--bLrsE";
export const iframeWrap = "propertyDetails-module--iframeWrap--AfVA7";
export const tagsWrap = "propertyDetails-module--tagsWrap--1nYMI";
export const tagGroup = "propertyDetails-module--tagGroup--3ezCL";
export const tagItem = "propertyDetails-module--tagItem--3V3wD";